import React from 'react'
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Drawer from '@material-ui/core/Drawer';
import AuditTrailViewer from '../AuditTrail';


const ActionBarViewer = (props) => {
   const { isButtonEnable, isExport, isAuditTrail, handleAuditTrailDrawerToggle, auditTrailDrawerOpen, auditTrail, chartUniqueId, label, value, exportLabel, auditTrailLabel, blockState, handleExport } = props
    return (
        <div style={{ height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxSizing: 'border-box' }}>
            <div style={{ height: '40px', boxSizing: 'border-box', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', boxSizing: 'border-box' }}>
                    <div style={{ height: '20px', width: '2px', backgroundColor: '#3F51B5' }}>

                    </div>
                    <Typography style={{ fontSize: '14px', fontWeight: '400', color: '#5F6071', fontStyle: 'normal', lineHeight: '24px' }}>{`${label} :`}</Typography>
                    <Typography style={{ fontSize: '14px', fontWeight: '400', color: '#2B2C35', fontStyle: 'normal', lineHeight: '24px' }}>{blockState?.[value]}</Typography>
                </div>
            </div>
            {
                isButtonEnable && (
                    <div style={{ height: '35px', boxSizing: 'border-box', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
                        {
                            isExport && <Button
                                style={{ backgroundColor: '#3F51B5', color: '#fff', border: '1px solid #3F51B5', borderRadius: '4px', height: '35px', padding: '12px', boxSizing: 'border-box' }}
                                onClick={() => { handleExport(blockState?._id || blockState?.id, blockState) }}
                            >
                                {exportLabel}
                            </Button>
                        }
                        {
                            isAuditTrail && <Button
                                style={{ color: '#3F51B5', border: '1px solid #3F51B5', borderRadius: '4px', height: '35px', padding: '12px', boxSizing: 'border-box' }}
                                onClick={handleAuditTrailDrawerToggle}

                            >
                                {auditTrailLabel}
                            </Button>
                        }
                    </div>
                )
            }

            {
                isButtonEnable && isAuditTrail && (
                    <Drawer
                        anchor="right"
                        open={auditTrailDrawerOpen}
                        onClose={handleAuditTrailDrawerToggle}
                        PaperProps={{
                            style: {
                                width: '960px'
                            },
                        }}
                    >
                        <AuditTrailViewer {...props} auditTrail={auditTrail} chartUniqueId={chartUniqueId} handleAuditTrailDrawerToggle={handleAuditTrailDrawerToggle} />
                    </Drawer>
                )
            }

        </div>
    )
}

export default ActionBarViewer